document.addEventListener('DOMContentLoaded', () => {
    const customerGrid = document.querySelector('#customers-grid');
    const buttons = document.querySelectorAll('.school-types input');

    function fetchStories() {
        const activeSchools = [];
        buttons.forEach((item) => {
            if (item.checked) {
                activeSchools.push(item.dataset['school']);
            }
        });


        const data = new FormData();

        data.append('action', 'get_schools')
        data.append('schools', activeSchools)

        fetch(window.urls.ajax, {
            method: "POST",
            body: data
        }).then((response) => {
            customerGrid.classList.add('loading');
            customerGrid.style.height = customerGrid.offsetHeight;
            customerGrid.innerHTML = '';

            return response.json();
        }).then((data) => {

            customerGrid.insertAdjacentHTML('beforeend', data);
            customerGrid.classList.remove('loading');

        }).catch(function (err) {
            console.warn('Something went wrong.', err);
        });
    }

    buttons.forEach((item) => {
        item.addEventListener('change', (e) => {
            fetchStories();
        });
    });
});